export enum ReviewEntryStatusKeyword {
  Approved = 'approved',
  Invalidated = 'invalidated',
  Pending = 'pending',
  Review = 'review',
  Reviewed = 'reviewed',
  Validate = 'validate',
  Validated = 'validated',
  Warning = 'warning',
}
